import React from 'react'
import "./description-template.css";

const DescriptionTemplatePure = ({ description }) => {
  // Function to parse description and apply bold to email within parentheses
  const parseDescription = (text) => {
    if (!text) return text;

    // Regex to match email within parentheses, e.g., (email@example.com)
    const emailRegex = /\(([^)]+@[^)]+)\)/g;

    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = emailRegex.exec(text)) !== null) {
      // Add text before the match
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }

      // Add the parenthesis opening, bold email, and parenthesis closing
      parts.push('(');
      parts.push(<strong key={match.index}>{match[1]}</strong>);
      parts.push(')');

      lastIndex = match.index + match[0].length;
    }

    // Add remaining text
    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    return parts.length > 0 ? parts : text;
  };

  return (
    <div className="descriptionTemplatePure-container">
      <p className="descriptionTemplatePure-description">{parseDescription(description)}</p>
    </div>
  )
}

export { DescriptionTemplatePure as default }
